module.exports = __webpack_public_path__ + "static/media/vs_code_npm_postman.0d4b0d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/vs_code_npm_postman.png
// module id = 416
// module chunks = 1